import { Route, Routes } from "react-router-dom";
import React from "react";
import Account from "../pages/Preferences/Account/Account";
import Settings from "../pages/Preferences/Settings";
import PlanAndBillings from "../pages/Preferences/PlanAndBillings/PlanAndBillings";
import Misc from "../pages/Preferences/Misc/Misc";
import Enterprise from "../pages/Preferences/Enterprise";
import { useLoginStatus } from "../context/LoginStatusContext";

const PreferencesRouter = () => {
  const { user } = useLoginStatus();
  const hasEnterpriseMemberships = user?.has_enterprise_memberships;

  return (
    <Routes>
      <Route path="account" element={<Account />} />
      <Route path="settings" element={<Settings />} />
      <Route path="plan-and-billings" element={<PlanAndBillings />} />
      {hasEnterpriseMemberships && <Route path="enterprise" element={<Enterprise />} />}
      <Route path="misc" element={<Misc />} />
    </Routes>
  );
};
export default PreferencesRouter;
